import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconLocked = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <clipPath id="prefixJd4OqXY9enNx4zMviKqtba">
          <rect width="16" height="16" rx="0" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefixJd4OqXY9enNx4zMviKqtba)">
        <path
          d="M10 6.5v-2a2 2 0 0 0-3.995-.15L6 4.5v2h4Zm2 2H4v5h8v-5Zm-8-3v-1a4 4 0 1 1 8 0v1c0 .346-.044.68-.126 1H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h.126A4.007 4.007 0 0 1 4 5.5Z"
          fill="#FA6400"
        />
      </g>
    </>
  ),
})``;

export default IconLocked;
